import React from "react";
import Login from "../pages/Login/Login";

const LayoutAuth = () => {
    return (
        <div>
            <Login />
        </div>
    );
};

export default LayoutAuth;
